import { FormCsiSubmit } from 'app/providers/csi/model/types';
import { useLayoutContext } from 'app/storage/LayoutContext';

/**
 * Single entry point for form-CSI (LayoutContext + CsiModal).
 *
 * NOTE: the `{ ...layoutState }` spread intentionally uses the state from the render closure
 * (same semantics as the legacy code). Switching to a functional updater changes the
 * csiRedirectPage behavior, so it is tracked as a separate task.
 * See: .agents/skills/asan-confirmation-refactor/SKILL.md
 */
export const useFormCsi = () => {
  const { layoutState, setLayoutState } = useLayoutContext();

  const open = (submit: FormCsiSubmit) => {
    setLayoutState({ ...layoutState, csiOpen: true, csiAction: submit });
  };

  const close = () => {
    setLayoutState({ ...layoutState, csiOpen: false });
  };

  const setRedirectPage = (page: string) => {
    setLayoutState({ ...layoutState, csiRedirectPage: page });
  };

  // Legacy: CsiModal stores the last rating in layout state (not read anywhere yet).
  const saveRating = (rating: number, comment: string) => {
    setLayoutState(prevState => ({ ...prevState, rating, comment }));
  };

  return {
    isOpen: layoutState.csiOpen,
    submit: layoutState.csiAction,
    redirectPage: layoutState.csiRedirectPage,
    open,
    close,
    setRedirectPage,
    saveRating,
  };
};
